import {openDrugsCategoryDrawer} from '@/modules/basic-data/categories/components/drugs-category-drawer/util'
import {ResourceTag, ResourceTagBehavior} from '@cypro/ui/components/ui/tags/resource-tag'
import {DrugsCategory} from '@cypro/engine/schema'

export interface DrugsCategoryTagProps {
  category?: DrugsCategory
  behavior?: ResourceTagBehavior
}

export function DrugsCategoryTag({category, ...props}: DrugsCategoryTagProps) {
  return (
    <ResourceTag
      {...props}
      onClick={() => category && openDrugsCategoryDrawer(category)}
      data-e2e="substance-category-tag"
      data-category-id={category?.id}
    >
      {category?.name}
    </ResourceTag>
  )
}
